import { render, staticRenderFns } from "./CheckboxEditor.vue?vue&type=template&id=47815693&"
import script from "./CheckboxEditor.vue?vue&type=script&lang=js&"
export * from "./CheckboxEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VInput } from 'vuetify/lib/components/VInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VInput,VTextField})
